import React, { useState } from "react";
import "../assets/css/youtube.css";
import ReactPlayer from "react-player/youtube";
import { ChevronLeft, ChevronRight, Pause, PlayIcon } from "lucide-react";

const Youtube = () => {
  const [isPlaying, setIsPlaying] = useState({
    player1: false,
    player2: false,
  });
  const [activeIndex, setActiveIndex] = useState(0);

  const handlePlaying = (key) => {
    setIsPlaying((prev) => {
      const newState = {};
      Object.keys(prev).forEach((playerKey) => {
        newState[playerKey] = playerKey === key ? !prev[key] : false;
      });
      return newState;
    });
  };
  

  const handleNext = () => {
    // setIsPlaying({ player1: false, player2: false });
    setActiveIndex((activeIndex) => {
      if (
        activeIndex < videoArray.length - 1 &&
        activeIndex !== videoArray.length - 1
      ) {
        return activeIndex + 1;
      } else {
        return 0;
      }
    });
  };

  const handlePrev = () => {
    setActiveIndex((activeIndex) => {
      if (activeIndex > 0) {
        return activeIndex - 1;
      } else if (activeIndex === 0) {
        return videoArray.length - 1;
      }
    });
  };
  return (
    <div className="iframe">
      <h2>Video Samples</h2>
      <div className="flex-box">
        {videoArray.map((item, index) => (
          <div
            key={index}
            className="iframe-box-container"
            style={{ translate: `${-102 * activeIndex}%` }}
          >
            <div className="iframe-box">
              <ReactPlayer
                url={item.url}
                width="100%"
                height="100%"
                playing={isPlaying[item.player]}
                controls={false}
                pip={true}
                light={false}
              />
              <button
                className="iframe-btn"
                onClick={() => handlePlaying(item.player)}
              >
                <span
                  style={
                    isPlaying[item.player] ? { opacity: 0 } : { opacity: 1 }
                  }
                >
                  {isPlaying[item.player] ? <PlayIcon /> : <Pause />}
                </span>
              </button>
            </div>
          </div>
        ))}
          <button className="radio-left" onClick={handleNext}>
            <ChevronLeft />
          </button>
          <button className="radio-right" onClick={handlePrev}>
            <ChevronRight />
          </button>
      </div>
      <div className="navigate-bottom">
      {videoArray.map((_item,i)=> <button className={`radio-bottom ${activeIndex === i ? "active" : ""}`} onClick={()=> setActiveIndex(i)}>{i + 1}</button>)}
      </div>
    </div>
  );
};
const videoArray = [
  {
    url: "https://youtube.com/shorts/FHs9JYHlYLs?modestbranding=1",
    player: "player1",
  },
  {
    url: "https://youtube.com/shorts/WjsRQRtLUf4?modestbranding=1",
    player: "player2",
  },
];
export default Youtube;
